export default __webpack_public_path__ + "static/media/car.ddb00107.svg";